//#region Styles
import { Container, CardLinkWrapper } from "./styles";
import { TitleSection } from "components/styles";
//#endregion
//#region Components
import CardLinkItemV2 from "components/CardLinkItem/secondary/CardLinkItemV2";
import HelmetUTP from "components/HelmetUTP/HelmetUTP";
//#endregion
//#region Utils
import { INFORMATION_LINKS } from "./utils/constants";
import { TOOLTIP_PROPS } from "components/CardLinkItem/secondary/utils/constants";
import { userHasPermission } from "config/userPermissions";
import { useEffect, useState } from "react";
//#endregion

const SettingsHome = ({
    userRole
}) => {
    const [filteredInformationLinks, setFilteredInformationLinks] = useState([]);
    useEffect(() => {
        setFilteredInformationLinks(INFORMATION_LINKS.filter(({ id: permission }) => userHasPermission(userRole, permission)));
    }, []);
    if (filteredInformationLinks.length === 0) 
        return null;
    return (
        <>
        <HelmetUTP title="Config."/>
        <Container>
            <TitleSection textAlign="center">Configuración</TitleSection>
            <CardLinkWrapper>
                {filteredInformationLinks
                .map(item => (
                    <CardLinkItemV2 
                        key={item.id} 
                        {...item}
                        tooltip={{
                            props: TOOLTIP_PROPS,
                            ...item.tooltip,
                        }}/>
                ))}
            </CardLinkWrapper>
        </Container>
        </>
    );
}

export default SettingsHome;